import axios from 'axios';
import { COMPANY_NOT_FOUND_FIELD } from '../constants';
import handleFormatCompaniesData from '../helper/handleFormatCompaniesData';

const SEARCH_COMPANIES_API_ENDPOINT = `${process.env.REACT_APP_API_URL}/public/search`;

export const getCompanies = async value => {
  try {
    const data = await axios.get(SEARCH_COMPANIES_API_ENDPOINT, {
      params: {
        name: value,
        count: 30,
      },
    });

    return handleFormatCompaniesData(data);
  } catch (err) {
    return [COMPANY_NOT_FOUND_FIELD];
  }
};
